export default "__VITE_ASSET__54769285__"